import { Navigate, useLocation } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthProvider";

const AdminRoute = ({ element }) => {
  const location=useLocation()
  const { user, loading } = useContext(AuthContext);
if(!loading){
  if (!user) {
    sessionStorage.setItem("redirectPath", location.pathname)
    return <Navigate to="/login" />;
  }
  if(!user.isAdmin){
    return <Navigate to="/user/my-dashboard"/>
  }
  return element; 
} 
  
};

export default AdminRoute;
